/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CountryCode {
  Ca = "CA",
  Us = "US",
}

export function instanceOfCountryCode(value: any): boolean {
  for (const key in CountryCode) {
    if (Object.prototype.hasOwnProperty.call(CountryCode, key)) {
      if (CountryCode[key as keyof typeof CountryCode] === value) {
        return true;
      }
    }
  }
  return false;
}

export function CountryCodeFromJSON(json: any): CountryCode {
  return CountryCodeFromJSONTyped(json, false);
}

export function CountryCodeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CountryCode {
  return json as CountryCode;
}

export function CountryCodeToJSON(value?: CountryCode | null): any {
  return value as any;
}

export function CountryCodeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CountryCode {
  return value as CountryCode;
}
